import { Button, DialogActions } from "@mui/material";

export default function DialogPrimaryAction({ onClick, disabled, color, children }) {
	return (
		<DialogActions sx={{ justifyContent: "center", pb: 3 }}>
			<Button variant="contained" color={color} onClick={onClick} disabled={disabled}>
				{children}
			</Button>
		</DialogActions>
	);
}
